@if (types) {
  <!-- a card for each type: its icon, how many there are, and its name; cards wrap onto more lines on a narrow panel -->
  <div class="type-grid" role="group" aria-label="Node types">
    @for (t of types; track t.name; let idx = $index) {
      <button type="button" class="type-tile" [class.selected]="selectedIndex === idx" [attr.aria-pressed]="selectedIndex === idx"
        (click)="selectType(idx)" [title]="t.name + ': ' + t.length">
        <span class="type-icon"><app-node-svg [type]="t.type" [noText]="true" [height]="34"/></span>
        <span class="type-text">
          <span class="type-count">{{t.length | number}}</span>
          <span class="type-name">{{t.name}}</span>
          @if (comparison) {
            <span class="type-compare" [title]="'In the comparison: ' + t.comparisonLength">vs {{t.comparisonLength | number}}</span>
          }
        </span>
      </button>
    }
  </div>
}
@if (selectedIndex !== undefined && types[selectedIndex]?.subTypes) {
  <div class="type-grid sub-types" role="group" aria-label="Kinds of the selected type">
    @for (t of types[selectedIndex].subTypes; track t.name; let idx = $index) {
      <button type="button" class="type-tile small" [class.selected]="selectedChildIndex === idx" [attr.aria-pressed]="selectedChildIndex === idx"
        (click)="selectChildType(idx)" [title]="t.name + ': ' + t.list.length">
        <span class="type-icon"><app-node-svg [type]="t.type" [noText]="true" [height]="24"/></span>
        <span class="type-text">
          <span class="type-count">{{t.list.length | number}}</span>
          <span class="type-name">{{t.name}}</span>
        </span>
      </button>
    }
  </div>
}
@if (selectedIndex === undefined) {
  <p class="choose">Choose a type to list its nodes.</p>
}@else if (isHelpOn()) {
  <div class="hint">{{getHelpMessage()}}</div>
}
